import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";
import {
  Table,
  Tooltip,
  Tag,
  Input,
  Button,
  Space,
  message,
  Drawer,
  Modal,
  Statistic,
  Row,
  Col,
  Typography,
  List,
  Descriptions,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./styles.scss";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { Column } from "@ant-design/plots";
import MainPie from "../../analytics/MainPie";

import LineTime from "../../analytics/LineTime";
import ColumnTime from "../../analytics/ColumnTime";
import ColumnGroupTime from "../../analytics/ColumnGroupTime";
import ColumnStackedTime from "../../analytics/ColumnStackedTime";

import { numberWithCommas } from "../../../utils/helpers";

import { fixbrockenpackages } from "../../../Redux/actions/packageActions";

import SalesExport from "../exports/salesExport";

const { Title } = Typography;

const Index = ({ maindata, datePickerValue, hideMoney = false }) => {
  const dispatch = useDispatch();

  const { crudData, crudDataCount, locations, user, currentProps } =
    useSelector(
      (state) => ({
        user: state.auth.user,
        crudData: state.analytics.data,
        crudDataCount: state.analytics.dataCount,
        locations: state.locations.locations,
        currentProps: state.analytics.currentProps,
      }),
      shallowEqual
    );

  const [categorySold, setCategorySold] = useState([]);
  const [productSold, setProductSold] = useState([]);

  const [locationSold, setLocationSold] = useState([]);
  const [locationSellerSold, setLocationSellerSold] = useState([]);
  const [locationOrderDiscountsTotal, setLocationOrderDiscountsTotal] =
    useState([]);

  const [allSold, setAllSold] = useState([]);

  const [categoryFilter, setCategoryFilter] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({});

  useEffect(() => {
    if (locations && maindata && currentProps) {
      if (currentProps.apiurl == "sales") {
        console.log(maindata);
        getbranchTotals(maindata);
      }
    }
  }, [maindata, locations]);

  useEffect(() => {
    console.log(selectedCategory);
    // console.log(categoryFilter)
  }, [categoryFilter, selectedCategory]);

  const getbranchTotals = () => {
    var locationProductCategories = [];
    var new_locationProductCategories = [];

    var allcats = [];
    var allcatids = [];

    var allprods = [];
    var allprodids = [];

    var allitems = [];

    maindata.map((pk) => {
      if (pk.products_sold) {
        pk.products_sold.map((item) => {
          var newrprod = {
            branch: pk.branch,
            branch_name: pk.branch_name,
            sold_at: pk.sale_date,
            day_sold: moment(pk.sale_date).format("YYYY-MM-DD"),
            category: item.category,
            category_name: item.category_name,
            product: item.key,
            product_name: item.name,
            unit: item.unit,
            quantity_sold: parseFloat(item.quantity_sold),
          };
          allitems.push(newrprod);

          if (!allprodids.includes(item.key)) {
            allprodids.push(item.key);
            var newrprod = {
              category: item.category,
              category_name: item.category_name,
              product: item.key,
              product_name: item.name,
              unit: item.unit,
              quantity_sold: item.quantity_sold,
            };
            allprods.push(newrprod);
          }
          if (!allcatids.includes(item.category)) {
            allcatids.push(item.category);
            var newcat = {
              category: item.category,
              category_name: item.category_name,
            };
            allcats.push(newcat);
          }
        });
      }
    });

    locations.map((loc) => {
      var cats = [];
      var catids = [];

      var prods = [];
      var prodids = [];

      console.log(allitems);

      allitems.map((item) => {
        if (item.branch == loc.id) {
          if (!catids.includes(item.category)) {
            catids.push(item.category);
            var newcat = {
              category: item.category,
              category_name: item.category_name,
            };
            cats.push(newcat);
          }

          if (!prodids.includes(item.product)) {
            prodids.push(item.product);
            var newrprod = {
              category: item.category,
              category_name: item.category_name,
              product: item.product,
              product_name: item.product_name,
              unit: item.unit,
              quantity_sold: item.quantity_sold,
              total_sold: 0,
            };
            prods.push(newrprod);
          }
        }
      });

      var newlocprodcats = {
        categories: cats,
        products: prods,
        location: loc.id,
        loc_name: loc.name,
        commissary: loc.commissary,
      };

      locationProductCategories.push(newlocprodcats);
    });

    locationProductCategories.map((loc) => {
      var this_products = [];
      var this_categories = [];

      var this_products_total = 0;
      var this_categories_total = 0;

      loc.products.map((prod) => {
        var prod_total = 0;
        allitems.map((it) => {
          if (loc.location == it.branch && prod.product == it.product) {
            prod_total += parseFloat(it.quantity_sold);
          }
        });
        var new_prod = {
          ...prod,
          total_sold: prod_total,
        };
        this_products_total += prod_total;
        this_products.push(new_prod);
      });

      loc.categories.map((cat) => {
        var cat_total = 0;
        allitems.map((it) => {
          if (loc.location == it.branch && cat.category == it.category) {
            cat_total += parseFloat(it.quantity_sold);
          }
        });
        var new_cat = {
          ...cat,
          total_sold: cat_total,
        };
        this_categories_total += cat_total;
        this_categories.push(new_cat);
      });

      console.log(
        this_categories_total == this_products_total,
        this_categories_total,
        this_products_total
      );

      var newlocprodcats = {
        categories: this_categories,
        products: this_products,
        location: loc.location,
        loc_name: loc.loc_name,
        commissary: loc.commissary,
      };
      new_locationProductCategories.push(newlocprodcats);
    });

    var prod_sum = [];
    var cat_sum = [];

    allprodids.map((id) => {
      var prod_total = 0;
      var currentItem = null;
      allitems.map((item) => {
        if (item.product == id) {
          prod_total += parseFloat(item.quantity_sold);
          currentItem = item;
        }
      });
      var newrprod = {
        category: currentItem.category,
        category_name: currentItem.category_name,
        product: currentItem.product,
        product_name: currentItem.product_name,
        unit: currentItem.unit,
        total_sold: prod_total,
      };
      prod_sum.push(newrprod);
    });

    allcatids.map((id) => {
      var cat_total = 0;
      var currentItem = null;
      allitems.map((item) => {
        if (item.category == id) {
          cat_total += parseFloat(item.quantity_sold);
          currentItem = item;
        }
      });
      var newrprod = {
        category: currentItem.category,
        category_name: currentItem.category_name,
        total_sold: cat_total,
      };
      cat_sum.push(newrprod);
    });

    // console.log(new_locationProductCategories)
    setLocationSold(new_locationProductCategories);
    // console.log(prod_sum)
    setProductSold(prod_sum);
    // console.log(cat_sum)
    setCategorySold(cat_sum);

    // console.log(allitems)

    setAllSold(allitems);
  };

  /////////////////// new totals
  const {
    branchTotals,
    branchTotalsArr,
    sellerTotals,
    sellerTotalsArr,
    sellerBranchMap,
    branchSellersMap,
  } = computeSalesStats(maindata);
  // Safe number parser
  function num(v, d = 0) {
    return Number.isFinite(v) ? v : v == null ? d : Number(v) || d;
  }

  // Compute per-branch & per-seller metrics + seller↔branch maps
  function computeSalesStats(maindata) {
    const branchTotals = {};
    const sellerTotals = {};

    // New: maps for seller↔branch relationships
    const sellerBranchMap = {};
    const branchSellersMap = {};

    for (const sale of maindata || []) {
      const branchId = sale.branch || "unknown";
      const branchName = sale.branch_name;

      const itemsDisc = num(sale.breakdown && sale.breakdown.itemsDiscount, 0);
      const orderDisc = num(sale.breakdown && sale.breakdown.orderDisc, 0);

      let lineDisc = 0;
      if (sale.products_sold && sale.products_sold.length) {
        for (const it of sale.products_sold) {
          lineDisc += num(it.line_discount, 0);
        }
      }

      const includeLineDiscounts = false;
      const totalDiscount =
        itemsDisc + orderDisc + (includeLineDiscounts ? lineDisc : 0);
      const totalSell = num(sale.total_sell_price, 0);

      // ---- per branch totals ----
      if (!branchTotals[branchId]) {
        branchTotals[branchId] = {
          branch: branchId,
          branch_name: branchName,
          totalSell: 0,
          totalDiscount: 0,
        };
      }
      branchTotals[branchId].totalSell += parseFloat(totalSell);
      branchTotals[branchId].totalDiscount += parseFloat(totalDiscount);

      // ---- per seller totals ----
      const sellerId =
        sale.seller && sale.seller.id
          ? sale.seller.id
          : `${sale.branch_name} seller`;
      const sellerName =
        sale.seller && sale.seller.name ? sale.seller.name : "no name";
      const sellerBranchId = (sale.seller && sale.seller.branch) || branchId;
      const sellerBranchName =
        (sale.seller && sale.seller.branch_name) || branchName;

      if (!sellerTotals[sellerId]) {
        sellerTotals[sellerId] = {
          sellerId,
          sellerName,
          // last-seen branch info (may move, see sellerBranchMap for full history)
          branch: sellerBranchId,
          branch_name: sellerBranchName,
          totalSell: 0,
          totalDiscount: 0,
        };
      }
      sellerTotals[sellerId].totalSell += parseFloat(totalSell);
      sellerTotals[sellerId].totalDiscount += parseFloat(totalDiscount);

      // ---- seller → branches detail ----
      if (!sellerBranchMap[sellerId]) {
        sellerBranchMap[sellerId] = {
          sellerId,
          sellerName,
          branches: {}, // branchId -> { branchId, branch_name, totalSell, totalDiscount }
          primaryBranchId: null, // we’ll compute later
        };
      }
      if (!sellerBranchMap[sellerId].branches[sellerBranchId]) {
        sellerBranchMap[sellerId].branches[sellerBranchId] = {
          branchId: sellerBranchId,
          branch_name: sellerBranchName,
          totalSell: 0,
          totalDiscount: 0,
        };
      }
      sellerBranchMap[sellerId].branches[sellerBranchId].totalSell += totalSell;
      sellerBranchMap[sellerId].branches[sellerBranchId].totalDiscount +=
        totalDiscount;

      // ---- branch → sellers detail ----
      if (!branchSellersMap[branchId]) {
        branchSellersMap[branchId] = {
          branchId,
          branch_name: branchName,
          sellers: {}, // sellerId -> { sellerId, sellerName, totalSell, totalDiscount }
        };
      }
      if (!branchSellersMap[branchId].sellers[sellerId]) {
        branchSellersMap[branchId].sellers[sellerId] = {
          sellerId,
          sellerName,
          totalSell: 0,
          totalDiscount: 0,
        };
      }
      branchSellersMap[branchId].sellers[sellerId].totalSell += totalSell;
      branchSellersMap[branchId].sellers[sellerId].totalDiscount +=
        totalDiscount;
    }

    // Sort arrays for UI friendliness
    const branchTotalsArr = Object.values(branchTotals).sort((a, b) =>
      (a.branch_name || "").localeCompare(b.branch_name || "")
    );
    const sellerTotalsArr = Object.values(sellerTotals).sort((a, b) =>
      (a.sellerName || "").localeCompare(b.sellerName || "")
    );

    // Compute primaryBranchId per seller (branch with highest totalSell)
    for (const sId of Object.keys(sellerBranchMap)) {
      const sb = sellerBranchMap[sId];
      let bestBranch = null;
      let bestSell = -1;
      for (const bId of Object.keys(sb.branches)) {
        const sell = sb.branches[bId].totalSell;
        if (sell > bestSell) {
          bestSell = sell;
          bestBranch = bId;
        }
      }
      sb.primaryBranchId = bestBranch;
    }

    console.log({
      branchTotals,
      branchTotalsArr,
      sellerTotals,
      sellerTotalsArr,
      sellerBranchMap,
      branchSellersMap,
    });

    return {
      branchTotals,
      branchTotalsArr,
      sellerTotals,
      sellerTotalsArr,
      sellerBranchMap,
      branchSellersMap,
    };
  }

  const renderProdcutsTable = (thisdata) => {
    const columns = [
      {
        title: "Category",
        dataIndex: "category_name",
        defaultSortOrder: "category_name",
        sorter: {
          compare: (a, b) => a.category_name.localeCompare(b.category_name),
          multiple: 1,
        },
      },

      {
        title: "Product",
        dataIndex: "product_name",
        defaultSortOrder: "product_name",
        sorter: {
          compare: (a, b) => a.product_name.localeCompare(b.product_name),
          multiple: 1,
        },
      },

      {
        title: "Quantity",
        dataIndex: "total_sold",
        defaultSortOrder: "total_sold",
        sorter: (a, b) => a.total_sold - b.total_sold,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "unit",
        dataIndex: "unit",
        defaultSortOrder: "unit",
      },
    ];
    return (
      <Table
        columns={columns}
        dataSource={thisdata}
        size={"small"}
        className="thistable"
        pagination={{
          pageSizeOptions: [25, 50, 100],
          defaultPageSize: 25,
        }}

        //   onRow={(record, rowIndex) => {
        //     return {
        //       onClick: event => {console.log(record)}, // click row

        //     };
        // }}
      />
    );
  };

  const changeCategoryFilter = (e, loc) => {
    var new_categoryFilter = {
      ...categoryFilter,
    };
    new_categoryFilter[loc] = e;
    setCategoryFilter(new_categoryFilter);
  };

  const changeSelectedCategory = (e, loc) => {
    // var new_selectedCategory ={
    //   ...selectedCategory
    // }
    // new_selectedCategory[loc]=e
    setSelectedCategory(e);
  };

  const filteredthetable = (spending, loc) => {
    if (selectedCategory) {
      var ccat = selectedCategory;
      var newspending = spending.filter((i) => i.category == ccat.category);
      return newspending;
    } else {
      return spending;
    }
  };

  const filterdatabybranch = (sold, loc) => {
    var filsold = sold.filter((i) => i.branch == loc);
    return filsold;
  };

  return (
    <div className="analytics_locations_container">
      <div>
        <Column
          data={allSold}
          isStack={true}
          xField={"day_sold"}
          yField={"quantity_sold"}
          seriesField={"branch_name"}
          tooltip={{
            formatter: (datum: Datum) => {
              return {
                name: datum.branch_name,
                value: ` ${
                  datum.quantity_sold
                    ? numberWithCommas(
                        parseFloat(datum.quantity_sold).toFixed(2)
                      )
                    : 0
                }`,
              };
            },
          }}
          label={{
            formatter: (v) => {},
            // 可手动配置 label 数据标签位置
            position: "middle",
            // 'left', 'middle', 'right'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              {
                type: "interval-adjust-position",
              }, // 数据标签防遮挡
              {
                type: "interval-hide-overlap",
              }, // 数据标签文颜色自动调整
              {
                type: "adjust-color",
              },
            ],
          }}
        />
      </div>

      <div className="mainoverall">
        <div className="flex3 column">
          <Title level={3} style={{ marginTop: "1.5em" }}>
            <div className="titlerow">
              <span>Overall</span>
              <div className="titlerow">
                {selectedCategory ? (
                  <Button
                    onClick={() => {
                      changeSelectedCategory(null, "overall");
                    }}
                  >
                    Reset Table
                  </Button>
                ) : null}
                <SalesExport
                  values={productSold}
                  datePickerValue={datePickerValue}
                  name={"Overall"}
                />
              </div>
            </div>
          </Title>
          {renderProdcutsTable(filteredthetable(productSold, "overall"))}
        </div>
        <div className="flex1 paddingpie column">
          <MainPie
            currentData={categorySold}
            colorField={"category_name"}
            angleField={"total_sold"}
            onSelectedCategories={(e) => {
              changeCategoryFilter(e, "overall");
            }}
            onCurrentSelectedCategory={(e) => {
              changeSelectedCategory(e, "overall");
            }}
          />
          {selectedCategory ? (
            <MainPie
              currentData={filteredthetable(productSold, "overall")}
              colorField={"product_name"}
              angleField={"total_sold"}
            />
          ) : null}
          {/* {selectedCategory['overall'] ? 
            <MainPie  currentData={filteredthetable(productSold,'overall')} 
                colorField={'product_name'}  angleField={'quantity'} 
             
            />
            :null
            } */}
        </div>
      </div>
      <Title level={3} style={{ marginTop: "1.5em" }}>
        Locations
      </Title>
      <List
        itemLayout="vertical"
        size="large"
        pagination={false}
        dataSource={locationSold}
        renderItem={(item) => {
          console.log("locations ITEM", item);
          var branchTotal = branchTotals[item.location];
          var branchSellers = sellerTotalsArr.filter(
            (x) => item.location == x.branch
          );

          if (!item.commissary && item.products.length > 0) {
            return (
              <List.Item
                key={`${item.location}_sales`}
                extra={
                  <div className="flex1 paddingpie column">
                    {!hideMoney ? (
                      <>
                        <Statistic
                          title="TOTAL SELL"
                          value={numberWithCommas(
                            parseFloat(branchTotal.totalSell).toFixed(2)
                          )}
                          prefix={"PHP"}
                        />
                        <Statistic
                          title="TOTAL DISCOUNT"
                          value={numberWithCommas(
                            parseFloat(branchTotal.totalDiscount).toFixed(2)
                          )}
                          prefix={"PHP"}
                        />
                      </>
                    ) : null}
                    <MainPie
                      currentData={item.categories}
                      colorField={"category_name"}
                      angleField={"total_sold"}
                      onSelectedCategories={(e) => {
                        changeCategoryFilter(e, item.location);
                      }}
                      onCurrentSelectedCategory={(e) => {
                        changeSelectedCategory(e, item.location);
                      }}
                    />
                    {selectedCategory ? (
                      <MainPie
                        currentData={filteredthetable(
                          item.products,
                          item.location
                        )}
                        colorField={"product_name"}
                        angleField={"total_sold"}
                      />
                    ) : null}

                    {!hideMoney && branchSellers.length > 0 ? (
                      <MainPie
                        currentData={branchSellers}
                        colorField={"sellerName"}
                        angleField={"totalSell"}
                      />
                    ) : null}
                  </div>
                }
              >
                <List.Item.Meta
                  // avatar={<Avatar src={item.avatar} />}
                  title={
                    <div className="titlerow">
                      <span>{item.loc_name}</span>
                      <div className="titlerow">
                        {selectedCategory ? (
                          <Button
                            onClick={() => {
                              changeSelectedCategory(null, item.location);
                            }}
                          >
                            Reset Table
                          </Button>
                        ) : null}
                        <SalesExport
                          values={item.products}
                          datePickerValue={datePickerValue}
                          name={item.loc_name}
                        />
                      </div>
                    </div>
                  }
                  description={
                    <div className="stats">
                      <Descriptions size={"small"}>
                        {/* <Descriptions.Item label="Total Items">{`Php ${numberWithCommas(item.itemtotal.toFixed(2))}`}</Descriptions.Item>
                      <Descriptions.Item label="Total Shipping">{`Php ${numberWithCommas(item.shippingtotal.toFixed(2))}`}</Descriptions.Item>
                      <Descriptions.Item label="Total Spent">{`Php ${numberWithCommas((item.itemtotal + item.shippingtotal).toFixed(2))}`}</Descriptions.Item> */}
                      </Descriptions>
                    </div>
                  }
                />
                <Column
                  data={filterdatabybranch(allSold, item.location)}
                  isStack={true}
                  xField={"day_sold"}
                  yField={"quantity_sold"}
                  seriesField={"category_name"}
                  tooltip={{
                    formatter: (datum) => {
                      return {
                        name: datum.category_name,
                        value: ` ${
                          datum.quantity_sold
                            ? numberWithCommas(
                                parseFloat(datum.quantity_sold).toFixed(2)
                              )
                            : 0
                        }`,
                      };
                    },
                  }}
                  label={{
                    formatter: (v) => {},
                    // 可手动配置 label 数据标签位置
                    position: "middle",
                    // 'left', 'middle', 'right'
                    // 可配置附加的布局方法
                    layout: [
                      // 柱形图数据标签位置自动调整
                      {
                        type: "interval-adjust-position",
                      }, // 数据标签防遮挡
                      {
                        type: "interval-hide-overlap",
                      }, // 数据标签文颜色自动调整
                      {
                        type: "adjust-color",
                      },
                    ],
                  }}
                />
                {renderProdcutsTable(
                  filteredthetable(item.products, item.location)
                )}
              </List.Item>
            );
          }
        }}
      />
    </div>
  );
};

export default Index;
